import { Tooltip } from '@chakra-ui/react';
import styles from './OrganisationStatusCellRenderer.module.css';
import { Box, Text } from '@chakra-ui/react';
import CompanyStatuses from '../utils/statuses';

const OrganisationStatusCellRenderer = ({ value, noCircle, statusMessage }) => {
    const tooltipLabel =
        (CompanyStatuses[value]?.toolTip
            ? CompanyStatuses[value]?.toolTip
            : '') + (statusMessage ? `: ${statusMessage}` : '');

    const noMessage = !statusMessage && !CompanyStatuses[value]?.toolTip;

    const displayName = CompanyStatuses[value]?.displayedName || 'Unknown';

    return (
        <Tooltip
            hasArrow
            disabled={noMessage}
            maxW="400px"
            width="auto"
            label={!noMessage && <Text textAlign="left">{tooltipLabel}</Text>}
            aria-label={CompanyStatuses[value]?.toolTip}>
            <Box
                className={`${styles.tag} ${styles[CompanyStatuses[value]?.type + 'Tag']}`}
                sx={{
                    display: 'flex',
                    alignItems: noCircle ? 'center' : null,
                    justifyContent: noCircle ? 'center' : null,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {!noCircle && (
                    <div
                        className={`${styles.circle} ${styles[CompanyStatuses[value]?.type + 'Circle']}`}
                    />
                )}
                <Text isTruncated>{displayName}</Text>
            </Box>
        </Tooltip>
    );
};

export default OrganisationStatusCellRenderer;
